import { environment } from '@env/environment'
import { Component, OnInit } from '@angular/core'
import { AuthService } from '@services/auth.service'
import { NavigationService } from '@modules/navigation/services'
import { map } from 'rxjs/operators'

@Component({
    selector: 'app-landing-page-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent implements OnInit {
    urlLogin: string
    isMenuOpen = false

    constructor(private navigationService: NavigationService, public authService: AuthService) {
    }

    ngOnInit() {
        this.urlLogin = environment.urlLogin
    }

    toggleMenu(): void {
        this.isMenuOpen = !this.isMenuOpen
    }

    closeMenu(): void {
        this.isMenuOpen = false
    }

    redirectSession() {
        this.authService.redirectToBoard(this.authService.session)
    }

    get slugName$() {
        return this.authService.user$.pipe(
            map(user => user?.name?.substring(0, 2)?.toUpperCase())
        )
    }

    get urlState() {
        return this.navigationService.currentURL$()
    }
}
